export default class Constants {
  static BACK_HOST_URI_PREFIX = '/spd/';
  static getBackFieldsFunctionCodeUrl = () => parseInt(localStorage.getItem('hospital_version_hmmBack') || '2514') > 2514 ? '/remote-system/remote/getFieldsByMenuFunctionCode' : '/plat-delivery/remote/getFieldsByMenuFunctionCode';

  /** 返回结果代码-忽略 */
  static RESPONSE_CODE_SKIP = '0';
  /** 返回结果代码-正常 */
  static RESPONSE_CODE_SUCCESS = '1';

  /** 错误消息代码-需要验证码 */
  static ERROR_CODE_NEED_CAPTCHA = 'EWCOM003';

  // 不包含验证码的最大登录失败次数
  static MAX_LOGIN_ERROR_CNT_WITHOUT_CAPTCHA = 1;

  static MESSAGE_LEVEL_WARNING = 'warning';

  // 排序MAP
  static sortMap = {
    ascend: 'ASC',
    descend: 'DESC'
  };

  /** 仓库类型-一级库 **/
  static WAREHOUSE_TYPE_WAREHOUSE = 1;
  /** 仓库类型-科室 **/
  static WAREHOUSE_TYPE_DEPARTMENT = 2;
  /** 仓库类型-供应室 **/
  static WAREHOUSE_TYPE_SUPPLIER = 3;
  /** 仓库类型-小组 **/
  static WAREHOUSE_TYPE_TEAM = 4;

  /** 是否供应商可见-是 **/
  static SUPPLIER_VISIBLE_YES = 1;
  /** 是否供应商可见-否 **/
  static SUPPLIER_VISIBLE_NO = 0;

  // 操作类型--复制添加
  static ACTION_TYPE_ADD = 0;
  // 操作类型--复制添加
  static ACTION_TYPE_COPY_ADD = 1;
  // 操作类型--删除
  static ACTION_TYPE_DELETE = 2;
  // 操作类型--编辑
  static ACTION_TYPE_EDIT = 3;

  // 预置标志--预置
  static PREDEFINED_FLAG_YES = 1;
  // 预置标志--非预置
  static PREDEFINED_FLAG_NO = 0;

  // 操作-添加、复制添加
  static UPDATE_FLAG_CREATE = 1;
  // 操作-编辑
  static UPDATE_FLAG_MODIFY = 2;
  // 操作-删除
  static UPDATE_FLAG_DELETE = 3;

  /** 显示明细方式 -- 首次打开 */
  static ENTER_SPOT_SHOW = 1;
  /** 显示明细方式 -- 打开后查询显示 */
  static ENTER_SPOT_SEARCH = 2;

  // 系统类型:0系统
  static SYSTEM_TYPE_SYS = 0;
  // 系统类型:1平台
  static SYSTEM_TYPE_PLAT = 1;
  // 系统类型:2医院
  static SYSTEM_TYPE_HOS = 2;
  // 系统类型:3供应商
  static SYSTEM_TYPE_SUP = 3;

  // 区分:（1,普耗；2，高值; 3, 试剂；4，药品）
  static ITEM_CLASS_CSM = 1;
  static ITEM_CLASS_HIGH_VALUE = 2;
  static ITEM_CLASS_REAGENT = 3;
  static ITEM_CLASS_MED = 4;
  static ITEM_CLASS_OFF = 5;
  static ITEM_CLASS_EQU = 6;

  // 区分二进制:（1,普耗；2，高值; 4, 试剂；8，药品, 16：总务）
  static ITEM_CLASS_SET_CSM = 1;
  static ITEM_CLASS_SET_HIGH_VALUE = 2;
  static ITEM_CLASS_SET_REAGENT = 4;
  static ITEM_CLASS_SET_MED = 8;
  static ITEM_CLASS_SET_OFF = 16;
  static ITEM_CLASS_SET_EQU = 32;

  /** 订单类型 - 1：普耗 */
  static ORDER_TYPE_CSM = 1;
  /** 订单类型 - 2：高值 */
  static ORDER_TYPE_HIGH_VALUE = 2;
  /** 订单类型 - 3：试剂 */
  static ORDER_TYPE_REAGENT = 3;
  /** 订单类型 - 4：药品 */
  static ORDER_TYPE_MED = 4;
  /** 订单类型 - 5：总务 */
  static ORDER_TYPE_OFF = 5;

  /** 发货单区分 - 1：普耗 */
  static DELIVERY_TYPE_CSM = 1;
  /** 发货单区分 - 2：高值 */
  static DELIVERY_TYPE_HIGH_VALUE = 2;
  /** 发货单区分 - 3：试剂 */
  static DELIVERY_TYPE_REAGENT = 3;
  /** 发货单区分 - 4：药品 */
  static DELIVERY_TYPE_MED = 4;
  /** 发货单区分 - 5：总务 */
  static DELIVERY_TYPE_OFF = 5;

  /** 发货单子类型 - 1：采购 */
  static DELIVERY_SUBTYPE_PURCHASE = 1;
  /** 发货单子类型 - 2：退货 */
  static DELIVERY_SUBTYPE_RETURN = 2;
  /** 发货单子类型 - 3：主动 */
  static DELIVERY_SUBTYPE_INITIATIVE = 3;
  /** 发货单子类型 - 4：手动 */
  static DELIVERY_SUBTYPE_MANUAL = 4;

  // 发货单类型-发货单
  static DELIVERY_TYPE_DELIVERY = 1;
  // 发货单类型-退货单
  static DELIVERY_TYPE_RETURN = 2;
  // 发货单类型-主动发货
  static DELIVERY_TYPE_INITIATIVE = 3;
  // 发货单类型-备货验收
  static DELIVERY_TYPE_STOCKUP = 4;
  // 发货单类型-备货退货
  static DELIVERY_TYPE_STOCKUP_RETURN = 5;

  // 发货单状态-新建
  static DELIVERY_STATUS_NEW = 0;
  // 发货单状态-待验收
  static DELIVERY_STATUS_ACCEPT_WAIT = 1;
  // 发货单状态-已拒收
  static DELIVERY_STATUS_REJECTED = 2;
  // 发货单状态-待确认
  static DELIVERY_STATUS_AFFIRM = 4;
  // 发货单状态-确认驳回
  static DELIVERY_STATUS_CONFIRM_REJECTED = 5;
  // 发货单状态-待入库
  static DELIVERY_STATUS_STOCK = 11;
  // 发货单状态-取消
  static DELIVERY_STATUS_CANCEL = 18;
  // 发货单状态-完成
  static DELIVERY_STATUS_COMPLETE = 19;
  // 发货单状态-过期
  static DELIVERY_STATUS_PASTDUE = 20;

  /** 组套审核状态-新建 **/
  static ITEMSET_STATUS_NEW = 0;
  /** 组套审核状态-待审核 **/
  static ITEMSET_STATUS_WAIT = 1;
  /** 组套审核状态-正常 **/
  static ITEMSET_STATUS_APPROVAL = 2;
  /** 组套审核状态-已驳回 **/
  static ITEMSET_STATUS_REJECT = 3;

  /** 结算状态-待审核 **/
  static STATEMENT_STATUS_WAIT = 1;
  /** 结算状态-已审核 **/
  static STATEMENT_STATUS_APPROVAL = 2;
  /** 结算状态-已确认 **/
  static STATEMENT_STATUS_CONFIRM = 3;
  /** 结算状态-发票提交 **/
  static STATEMENT_STATUS_INVOICE_SUBMISSION = 6;
  /** 结算状态-待付款 **/
  static STATEMENT_STATUS_PENDING_PAYMENT = 9;
  /** 结算状态-完成 **/
  static STATEMENT_STATUS_FINISH = 19;

  /** 骨科包状态-空置 **/
  static OPERATION_BOX_STATUS_EMPTY = 0;
  /** 骨科包状态-待提交 **/
  static OPERATION_BOX_STATUS_WAIT_SUBMIT = 1;
  /** 骨科包状态-待验收 **/
  static OPERATION_BOX_STATUS_WAIT_ACCEPT = 2;
  /** 骨科包状态-已驳回 **/
  static OPERATION_BOX_STATUS_REJECTED = 3;
  /** 骨科包状态-已验收 **/
  static OPERATION_BOX_STATUS_ACCEPTED = 5;
  /** 骨科包状态-已使用 **/
  static OPERATION_BOX_STATUS_USED = 6;

  /** 融资申请状态-新建 **/
  static FINANCE_APPLICATION_STATUS_NEW = 0;
  /** 融资申请状态-待审核 **/
  static FINANCE_APPLICATION_STATUS_WAIT = 1;
  /** 融资申请状态-审核中 **/
  static FINANCE_APPLICATION_STATUS_APPROVING = 2;
  /** 融资申请状态-完成 **/
  static FINANCE_APPLICATION_STATUS_COMPLETE = 19;

  /** 功能-采购计划 **/
  static DATA_EXCHANGE_FUNCTION_PLAN = 1;
  /** 功能-发货单 **/
  static DATA_EXCHANGE_FUNCTION_DELIVERY = 101;

  /** 操作类型-导入 **/
  static DATA_EXCHANGE_OPERATION_TYPE_IMPORT = 1;
  /** 操作类型-导出 **/
  static DATA_EXCHANGE_OPERATION_TYPE_EXPORT = 2;
  /** 操作类型-错误 **/
  static DATA_EXCHANGE_OPERATION_TYPE_ERROR = 99;

  /** 数据交换状态-待发送 **/
  static DATA_EXCHANGE_STATUS_PENDING = 0;
  /** 数据交换状态-已发送 **/
  static DATA_EXCHANGE_STATUS_SENT = 1;
  /** 数据交换状态-待处理 **/
  static DATA_EXCHANGE_STATUS_UNTREATED = 2;
  /** 数据交换状态-已处理 **/
  static DATA_EXCHANGE_STATUS_TREATED = 3;

  /** 菜单审核状态标识 --  0：没审 **/
  static MENU_ITEM_DONE_FLAG_NO = 0;
  /** 菜单审核状态标识 --  1：已审 **/
  static MENU_ITEM_DONE_FLAG_YES = 1;
  /** 菜单审核状态标识 --  3：换证申请 **/
  static MENU_ITEM_DONE_FLAG_REPLACE = 3;

  /** 菜单标题审核状态标识 --  0：全没审 **/
  static SUB_MENU_DONE_FLAG_NONE = 0;
  /** 菜单标题审核状态标识 --  1：部分审 **/
  static SUB_MENU_DONE_FLAG_PART = 1;
  /** 菜单标题审核状态标识 --  2：全部审 **/
  static SUB_MENU_DONE_FLAG_ALL = 2;
  /** 菜单标题审核状态标识 --  3：换证申请 **/
  static SUB_MENU_DONE_FLAG_REPLACE = 3;

  /** 菜单审核状态标识 --  -1：异常 **/
  static MENU_ITEM_DONE_FLAG_ABNORMAL = -1;
  /** 菜单审核状态标识 --  null：无资质 **/
  static MENU_ITEM_DONE_FLAG_NULL = null;
  /** 菜单审核状态标识 --  0：未提交 **/
  static MENU_ITEM_DONE_FLAG_NUNE = 0;
  /** 菜单审核状态标识 --  1：待审核 **/
  static MENU_ITEM_DONE_FLAG_REVIEWED = 1;
  /** 菜单审核状态标识 --  2：驳回 **/
  static MENU_ITEM_DONE_FLAG_REJECT = 2;
  /** 菜单审核状态标识 --  3：过期**/
  static MENU_ITEM_DONE_FLAG_OVERDUE = 3;
  /** 菜单审核状态标识 --  11：正常**/
  static MENU_ITEM_DONE_FLAG_NORMAL = 11;
  /** 菜单审核状态标识 --  12：即将过期**/
  static MENU_ITEM_DONE_FLAG_NEAROVERDUE = 12;
  /** 菜单审核状态标识 --  13：延期**/
  static MENU_ITEM_DONE_FLAG_DELAY = 13;
  /** 菜单审核状态标识 --  15：换证申请**/
  static MENU_ITEM_DONE_FLAG_RENEW = 15;
  /** 菜单审核状态标识 --  16：换证申请(待审核) **/
  static MENU_ITEM_DONE_FLAG_RENEWREVIEWED = 16;
  /** 菜单审核状态标识 --  20：多证无资质**/
  static MENU_ITEM_DONE_FLAG_MORENULL = 20;
  /** 菜单审核状态标识 --  21：多证正常**/
  static MENU_ITEM_DONE_FLAG_MOREABNRMAL = 21;
  /** 菜单审核状态标识 --  22：多证异常**/
  static MENU_ITEM_DONE_FLAG_MORENORMAL = 22;

  /** 江阴备码状态 --  1：未使用**/
  static JYZYY_STOCKUP_STATUS_NOT_USE = 1;
  /** 江阴备码状态 --  2：已验收**/
  static JYZYY_STOCKUP_STATUS_ACCEPTED = 2;
  /** 江阴备码状态 --  3：已使用**/
  static JYZYY_STOCKUP_STATUS_USED = 3;

  /** 植入性发货单状态 - 0：新建 */
  static IMPLANTATION_STATUS_NEW = 0;
  /** 植入性手术发货单：1 - 待确认 */
  static IMPLANTATION_STATUS_WAIT_CONFIRM = 1;
  /** 植入性手术发货单：2 - 已驳回 */
  static IMPLANTATION_STATUS_REJECTED = 2;
  /** 植入性手术发货单：3 - 待验收 */
  static IMPLANTATION_STATUS_WAIT_ACCEPT = 3;
  /** 植入性手术发货单：19 - 完成 */
  static IMPLANTATION_STATUS_COMPLETE = 19;

  /** 订单明细状态 - 0: 未发货  */
  static ORDER_DETAIL_STATUS_NOT_SEND = 0;
  /** 订单明细状态 - 1: 已发货  */
  static ORDER_DETAIL_STATUS_SENT = 1;
    /** 订单明细状态 - 6: 全部发货  */
    static ORDER_DETAIL_STATUS_ALL_SENT = 6;
  /** 订单明细状态 - 16: 取消订单  */
  static ORDER_DETAIL_STATUS_CANCEL = 16;
  /** 订单明细状态 - 17: 终止发货  */
  static ORDER_DETAIL_STATUS_CLOSE = 17;
  /** 订单明细状态 - 18: 终止订单  */
  static ORDER_DETAIL_STATUS_END = 18;
  /** 订单明细状态 - 19: 完成  */
  static ORDER_DETAIL_STATUS_FINISH = 19;

  /** 医院模块版本 - 后端 */
  static HOSPITAL_MODULE_HMM_BACK = 'hospital_version_hmmBack';
  /** 医院模块版本 - 管控 */
  static HOSPITAL_MODULE_HMM_ADMIN = 'hospital_version_admin';
  /** 医院模块版本 - 智能货架 */
  static HOSPITAL_MODULE_HMM_SHELVES = 'hospital_version_shelves';
  /** 医院模块版本 - 智能柜 */
  static HOSPITAL_MODULE_HMM_CABINET = 'hospital_version_cabinet';
  /** 医院模块版本 - 工单 */
  static HOSPITAL_MODULE_HMM_TRACK = 'hospital_version_track';
  /** 医院模块版本 - 运营大屏 */
  static HOSPITAL_MODULE_HMM_BIGSCREEN = 'hospital_version_bigscreen';
  /** 医院模块版本 - BI */
  static HOSPITAL_MODULE_HMM_BI = 'hospital_version_bi';

  // 是否为鼠标或键盘标识
  static ACTION_MOUSE = 1; // 鼠标
  static ACTION_KEYBOARD = 2; // 键盘

  /** 显示明细方式 -- 首次打开 */
  static ENTER_SPOT_SHOW = 1;
  /** 显示明细方式 -- 打开后查询显示 */
  static ENTER_SPOT_SEARCH = 2;

  // 流程标识（1耗材，4药品）
  /** 流程标识 - 耗材 */
  static PROCESS_FLAG_ITEM = 1;
  /** 流程标识 - 高值 */
  static PROCESS_FLAG_OPR = 2;
  /** 流程标识 - 药品 */
  static PROCESS_FLAG_MED = 4;

  /** 安康定制发货单状态-新建  */
  static AKZXDELIVERY_STATUS_NEW = 0;
  /** 安康定制发货单状态-待确认 */
  static AKZXDELIVERY_STATUS_CONFIRM = 1;
  /** 安康定制发货单状态-已拒收 */
  static AKZXDELIVERY_STATUS_REJECTED = 2;
  /** 安康定制发货单状态-待验收  */
  static AKZXDELIVERY_STATUS_ACCEPT_WAIT = 3;
  /** 发货单状态-已完成 */
  static AKZXDELIVERY_STATUS_COMPLETE = 19;
}
